import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonModule } from '@app/shared/common/app-common.module';
import { WebshopUtilsModule } from '@shared/utils/utils.module';
import { FileUploadModule } from 'ng2-file-upload';

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule as PrimeNgFileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { DragDropModule } from 'primeng/dragdrop';

import { CreateOrEditUserModalComponent } from './users/create-or-edit-user-modal.component';
import { ImpersonationService } from './users/impersonation.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxBootstrapDatePickerConfigService } from '@axilla/axilla-shared';
import { DropdownModule } from 'primeng/dropdown';

// Metronic
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AxillaCommonModule } from '@axilla/axilla-shared';
import {OrganizationUnitsTreeComponent} from '@app/admin/shared/organization-unit-tree.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FileUploadModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        WebshopUtilsModule,
        AxillaCommonModule,
        AppCommonModule,
        TableModule,
        TabViewModule,
        TreeModule,
        DragDropModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        EditorModule,
        InputMaskModule,
        NgxChartsModule,
        DropdownModule
    ],
    declarations: [
        OrganizationUnitsTreeComponent,
        CreateOrEditUserModalComponent,
    ],
    exports: [
        OrganizationUnitsTreeComponent,
        CreateOrEditUserModalComponent
    ],
    providers: [
        ImpersonationService,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale }
    ]
})
export class AdminLightModule { }
